import { Injectable } from '@angular/core';
import { Id } from '@shared/types/id';
import { map, Observable } from 'rxjs';
import { SequenceSearchResult } from '@features/sequence/models/sequence-search-result';
import { SequenceSearchResultApiService } from '@api/sequence/sequence-search-result-api.service';
import { SequenceSearchResultDetailsConverter } from '@features/sequence/converters/sequence-search-result-details.converter';
import { CollectionRequest } from '@api/common/requests/collection.request';
import { SequenceSearchResultHitCollectionItemResponse } from '@api/sequence/responses/sequence-search-result-hit-collection-item.response';

@Injectable({
  providedIn: 'root',
})
export class SequenceSearchResultActionService {
  constructor(
    private readonly sequenceSearchResultApi: SequenceSearchResultApiService,
    private readonly detailsConverter: SequenceSearchResultDetailsConverter
  ) {}

  fetch(id: Id): Observable<SequenceSearchResult> {
    return this.sequenceSearchResultApi
      .details(id)
      .pipe(map(response => this.detailsConverter.fromResponse(response)));
  }

  hits(id: Id): Observable<SequenceSearchResultHitCollectionItemResponse[]> {
    const request = new CollectionRequest(1, 10, true);

    return this.sequenceSearchResultApi
      .hits(id, request)
      .pipe(map(response => response.collection));
  }
}
